import { toast } from 'react-toastify';

import { ApiError, apiRequest } from '../../application/axios';
import { ADMINISTRATOR_API_URL } from '../../enviroments';
import { handleGlobalErrors } from '../../error/model/errors';

export const triggerChangedUsersSync = async () => {
    const response = await apiRequest<void>({
        url: `${ADMINISTRATOR_API_URL}/v1/administrators/synchronize`,
        method: 'post',
    });
    if (response instanceof ApiError) {
        toast.error(response.message);
        if (response.globalErrors) {
            handleGlobalErrors(response.globalErrors);
        }
        return;
    }
    toast.success(`Successfully triggered user import`);
};
